import { Component, forwardRef } from '@angular/core';
import { BlogsService } from 'src/app/settings/blogs/blogs.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';

@Component({
  selector: 'app-tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TagsComponent)
    }
  ]
})
export class TagsComponent implements ControlValueAccessor {

  cachedTags = [];
  tagsModel = [] as Array<Tag>;

  private _onChange = (_: any) => {};
  private _onTouched = (_: any) => {};

  constructor(
    private blogsApi: BlogsService,
  ) {
    this.blogsApi.getTags().subscribe((response) => {
      this.cachedTags = response.data.tags;
    });
  }
  onAdd(item: Tag) {
    this._onChange(this.tagsModel);
  }

  beforeAddHandler() {
    const self = this;
    return (tag: any) => {
      if (typeof tag === 'string') {
        const foundInCache = self.cachedTags.find(t => t.name.toLowerCase() === tag.toLowerCase());
        if (foundInCache) {
          return of(foundInCache);
        } else {
          return of(tag).pipe(
            switchMap((value) => {
              return this.blogsApi.addTag({name: value});
            }),
            map(response => {
              const newTag = response.data.tag;
              self.cachedTags.push(newTag);
              return newTag;
            })
          );
        }
      } else {
        return of(tag);
      }
    };
  }
  onRemove(item: Tag) {
    this._onChange(this.tagsModel);
  }

  onFocus() {
    this._onTouched(true);
  }


  registerOnChange(onChange) {
    this._onChange = onChange;
  }

  registerOnTouched(onTouched) {
    this._onTouched = onTouched;
  }

  writeValue(value) {
    this.tagsModel = value;
  }
}
export interface Tag {
  id: number;
  name: string;
  groupId?: string;
}
